import { render, staticRenderFns } from "./DiyCompetition2025.vue?vue&type=template&id=710028ee&scoped=true"
import script from "./DiyCompetition2025.vue?vue&type=script&lang=ts"
export * from "./DiyCompetition2025.vue?vue&type=script&lang=ts"
import style0 from "./DiyCompetition2025.vue?vue&type=style&index=0&id=710028ee&prod&lang=scss&scoped=true"
import style1 from "./DiyCompetition2025.vue?vue&type=style&index=1&id=710028ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710028ee",
  null
  
)

export default component.exports